import uuidv1 from 'uuid/v1';
export default {
  getRandomUUID: uuidv1,
};
